import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'

Vue.use(Vuex)
Vue.use(VueCookies)
const localCooki = window.localStorage
const sessionCooki = window.sessionStorage

// 调用
// var cookie_value1 = getCookie('sslToken')
var cookie_value = getCookie('lgwWap')
var cookie_value1 = getCookie('sslToken')


function getCookie(cookie_name) {
    var allcookies = document.cookie
    //索引长度，开始索引的位置
    var cookie_pos = allcookies.indexOf(cookie_name)

    // 如果找到了索引，就代表cookie存在,否则不存在
    if (cookie_pos != -1) {
        // 把cookie_pos放在值的开始，只要给值加1即可
        //计算取cookie值得开始索引，加的1为“=”
        cookie_pos = cookie_pos + cookie_name.length + 1
        //计算取cookie值得结束索引
        var cookie_end = allcookies.indexOf(';', cookie_pos)

        if (cookie_end == -1) {
            cookie_end = allcookies.length

        }
        //得到想要的cookie的值
        var value = unescape(allcookies.substring(cookie_pos, cookie_end))
    }
    return value
}

console.log('cookie_value', cookie_value);
console.log('cookie_value1', cookie_value1);
//
// if (cookie_value == undefined) {
//     localStorage.removeItem('isLogin')
//     localStorage.removeItem('userInfo')
// } else {
//     localStorage.setItem('isLogin', 'true')
//     localStorage.setItem('userInfo', JSON.stringify(JSON.parse(cookie_value)[0]))
// }

const store = new Vuex.Store({
    state: {
        isLogin: JSON.parse(localCooki.isLogin || 'false'),
        userInfo: JSON.parse(localCooki.userInfo || 'false'),
        http_ielts: 'https://www.thinkuprep.com/',
        // http_ielts: 'http://thinku-ielts.cc',
        http_gra: 'https://kaoyan.viplgw.cn',
        http_ielts_loc: 'http://192.168.0.176',

        http_open: 'https://open.viplgw.cn',
        http_bbs: 'https://bbs.viplgw.cn',
        userId: localCooki.userId,

        // http_bbs: 'http://bbs.cc',
    },
    // 事件触发
    actions: {
        isLogin({commit}) {
            commit('isLogin')
        },
        userInfo({commit}) {
            commit('userInfo')
        },
        userId({commit}) {
            commit('userId')
        }
    },
    // 突变
    mutations: {
        // 设置登录
        isLogin(state, val) {
            state.isLogin = val
        },
        userInfo(state, val) {
            state.userInfo = val
        },
        userId(state, val) {
            state.userId = val
        }
    },
    // 更新状态
    getters: {
        getLoginState(state) {
            return state.isLogin
        },
        getUserInfo(state) {
            if (state.isLogin) {
                localCooki.setItem('userInfo', JSON.stringify(state.userInfo))
            }
            return state.userInfo
        },
        getUserId(state) {
            return state.userId
        }
    }

})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js